// extracted by mini-css-extract-plugin
module.exports = {"NoDataSection":"NoDataSection_NoDataSection__1ABO8","NoDataSectionButton":"NoDataSection_NoDataSectionButton__38niQ"};